//#region libraries
import React, { useState, useEffect } from 'react';
//custom component
import { NavBar, Footer } from '_molecules';
//bootstrap
import { Container, Row, Col, Form, Button, Toast, ToastContainer } from 'react-bootstrap';
//responsive
import { useMediaQuery } from 'react-responsive'

import validator from 'validator';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { reset as resetContact, selectContactStatus, postMessage } from '_redux/slices/website/contact';
//#endregion

function DeleteAccount() {
    //#region state
    // state variables for form
    const [firstName, setFirstName] = useState("");
    const [secondName, setSecondName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [showSuccessText, setShowSuccessText] = useState(false);
    const [contactStatusText, setContactStatusText] = useState("init");
    //#endregion

    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })
    //#region redux
    const dispatch = useDispatch();
    const contactStatus = useSelector(selectContactStatus);
    //#endregion

    // handle submission
    const handleFormSubmission = (e) => {
        e.preventDefault(); // needed to prevent auto refresh

        let isValidEmail = validator.isEmail(email)
        let isValidFirst = validator.isEmpty(firstName)
        let isValidSecond = validator.isEmpty(secondName)
        let isValidMessage = validator.isEmpty(message)

        if (!isValidEmail) {
            toggleShowBadEmailToast();
        }
        if (isValidFirst) {
            toggleShowBadFirstToast();
        }
        if (isValidSecond) {
            toggleShowBadSecondToast();
        }
        if (isValidMessage) {
            toggleShowBadMessageToast();
        }
        if (isValidEmail && !isValidFirst && !isValidSecond && !isValidMessage && contactStatus != 'loading') {
            let fullName = firstName + ' ' + secondName;
            dispatch(postMessage({
                name: fullName,
                email: email,
                company: "DELETE ACCOUNT REQUEST",
                message: message
            }));
        }
    };

    //#region useEffects
    // intialize contact as empty on page opening
    useEffect(() => {
        dispatch(resetContact());
    }, []);

    // check on status of slice
    useEffect(() => {
        if (contactStatus == 'idle') setShowContactStatusToast(false);
        if (contactStatus == 'loading') {
            setContactStatusText(`Sending ${email} message...`);
        }
        else if (contactStatus == 'failed') {
            setContactStatusText(`Failed to send ${email} contact message`);
        }
        else if (contactStatus == 'succeeded') {
            setContactStatusText(`Sucessfully submitted your request`);
        }
        if (!showContactStatusToast && contactStatus != 'idle') {
            //toggleShowContactStatusToast();
            setShowSuccessText(true)
        }
    }, [contactStatus]);
    //#endregion

    //#region Toast
    // toasts for bad first name
    const [showBadFirstToast, setShowBadFirstToast] = useState(false);
    const toggleShowBadFirstToast = () => setShowBadFirstToast(!showBadFirstToast);

    //  toasts for bad second
    const [showBadSecondToast, setShowBadSecondToast] = useState(false);
    const toggleShowBadSecondToast = () => setShowBadSecondToast(!showBadSecondToast);

    // toasts for bad email
    const [showBadEmailToast, setShowBadEmailToast] = useState(false);
    const toggleShowBadEmailToast = () => setShowBadEmailToast(!showBadEmailToast);

    // toasts for bad message
    const [showBadMessageToast, setShowBadMessageToast] = useState(false);
    const toggleShowBadMessageToast = () => setShowBadMessageToast(!showBadMessageToast);

    // toasts for saving tester status
    const [showContactStatusToast, setShowContactStatusToast] = useState(false);
    const toggleShowContactStatusToast = () => setShowContactStatusToast(!showContactStatusToast);
    //#endregion

    if (!isPhone) {
        return (
            <Container>
                <NavBar />
                <Container fluid={true} className="mt-5">
                    <Container className="mt-5">
                        <Row>
                            <Col className='mt-5'>
                                <h1 className="fw-bold fs-1 mt-5">Delete Account</h1>
                                <p className="fw-lighter fs-4 mt-5">Get in touch with us by filling out this form and your account and data will be deleted</p>
                            </Col>
                            <Col className='mt-5'>
                                <Form onSubmit={handleFormSubmission}>
                                    {/* Name */}
                                    <Form.Group>
                                        <Row>
                                            <Form.Label>Name</Form.Label>
                                            <Col>
                                                <Form.Control placeholder="First" type="text" onChange={(e) => setFirstName(e.target.value)} />
                                            </Col>
                                            <Col>
                                                <Form.Control placeholder="Surname" type="text" onChange={(e) => setSecondName(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    {/* Email */}
                                    <Form.Group className="mb-3 mt-3" controlId="formEmail">
                                        <Row>
                                            <Form.Label> Email </Form.Label>
                                            <Col>
                                                <Form.Control type="text" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    {/* Message */}
                                    <Form.Group className="mt-4">
                                        <Row>
                                            <Form.Label>{"Reason (Optional)"}</Form.Label>
                                            <Col>
                                                <Form.Control as="textarea" style={{ height: '100px' }} type="text" placeholder="Type your message here..." onChange={(e) => setMessage(e.target.value)} />
                                            </Col>
                                        </Row>
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className='mt-5'>
                                        Submit
                                    </Button>
                                    {
                                        showSuccessText ?
                                            <p style={{ marginTop: 5, color: 'green' }}>{contactStatusText}</p>
                                            :
                                            null
                                    }
                                </Form>
                                {/* Toast */}
                                <ToastContainer position='bottom-end'>
                                    {/* first */}
                                    <Toast show={showBadFirstToast} onClose={toggleShowBadFirstToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid first name</Toast.Body>
                                    </Toast>
                                    {/* second */}
                                    <Toast show={showBadSecondToast} onClose={toggleShowBadSecondToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid second name</Toast.Body>
                                    </Toast>
                                    {/* email */}
                                    <Toast show={showBadEmailToast} onClose={toggleShowBadEmailToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid email address</Toast.Body>
                                    </Toast>
                                    {/* message */}
                                    <Toast show={showBadMessageToast} onClose={toggleShowBadMessageToast} bg='warning'>
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>Please enter a valid message</Toast.Body>
                                    </Toast>
                                    {/* status */}
                                    <Toast show={showContactStatusToast} onClose={toggleShowContactStatusToast} bg={contactStatus == 'failed' ? 'danger' : contactStatus == 'succeeded' ? 'success' : 'light'} >
                                        <Toast.Header>
                                            <strong className='me-auto'>PRM Assist</strong>
                                        </Toast.Header>

                                        <Toast.Body>{contactStatusText}</Toast.Body>
                                    </Toast>
                                </ToastContainer>
                            </Col>
                        </Row>
                    </Container>
                </Container>

                <Footer />
            </Container>
        );
    }
    else {
        return (
            <>
                <NavBar />
                <Container>
                    <Row>
                        <Col>
                            <h1 className="fw-bold fs-1 mt-5">Delete Account</h1>
                            <p className="fw-lighter fs-4 ">Get in touch with us by filling out this form and your account and data will be deleted</p>
                        </Col>
                    </Row>
                    <Row>
                        <Form onSubmit={handleFormSubmission}>
                            {/* Name */}
                            <Form.Group>
                                <Row>
                                    <Form.Label>Name</Form.Label>
                                    <Col>
                                        <Form.Control placeholder="First" type="text" onChange={(e) => setFirstName(e.target.value)} />
                                    </Col>
                                    <Col>
                                        <Form.Control placeholder="Surname" type="text" onChange={(e) => setSecondName(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Email */}
                            <Form.Group className="mb-3 mt-3" controlId="formEmail">
                                <Row>
                                    <Form.Label> Email </Form.Label>
                                    <Col>
                                        <Form.Control type="text" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Message */}
                            <Form.Group className="mt-4">
                                <Row>
                                    <Form.Label>{"Reason (Optional)"}</Form.Label>
                                    <Col>
                                        <Form.Control as="textarea" style={{ height: '100px' }} type="text" placeholder="Type your message here..." onChange={(e) => setMessage(e.target.value)} />
                                    </Col>
                                </Row>
                            </Form.Group>

                            <Button variant="primary" type="submit" className='mt-5'>
                                Submit
                            </Button>
                        </Form>
                        {/* Toast */}
                        <ToastContainer position='bottom-end'>
                            {/* first */}
                            <Toast show={showBadFirstToast} onClose={toggleShowBadFirstToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid first name</Toast.Body>
                            </Toast>
                            {/* second */}
                            <Toast show={showBadSecondToast} onClose={toggleShowBadSecondToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid second name</Toast.Body>
                            </Toast>
                            {/* email */}
                            <Toast show={showBadEmailToast} onClose={toggleShowBadEmailToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid email address</Toast.Body>
                            </Toast>
                            {/* message */}
                            <Toast show={showBadMessageToast} onClose={toggleShowBadMessageToast} bg='warning'>
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>Please enter a valid message</Toast.Body>
                            </Toast>
                            {/* status */}
                            <Toast show={showContactStatusToast} onClose={toggleShowContactStatusToast} bg={contactStatus == 'failed' ? 'danger' : contactStatus == 'succeeded' ? 'success' : 'light'} >
                                <Toast.Header>
                                    <strong className='me-auto'>PRM Assist</strong>
                                </Toast.Header>

                                <Toast.Body>{contactStatusText}</Toast.Body>
                            </Toast>
                        </ToastContainer>
                    </Row>
                </Container>

                <Footer />

            </>
        );
    }
};
//
export default DeleteAccount;